/*
 * @Author: your name
 * @Date: 2021-03-30 22:10:31
 * @LastEditTime: 2021-04-24 22:33:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\store\index.js
 */
import Vue from "vue";
import Vuex, { Store } from "vuex";
import BasicInfo from '@/store/BasicInfo';
import loginUser from '@/store/loginUser';

Vue.use(Vuex);

export default new Vuex.Store({
    // 配置
  state: {},
  mutations: {},
  actions: {},
  modules: {
    BasicInfo,
    loginUser
  }
});